import { MERGED_STATUSES, mergedStatusChip } from "./recipient-status";
import styles from "./MailingGroups.module.css";

// Legend copy for the merged status chips above the candidates table.
const LEGEND_HINTS: Record<string, string> = {
  new: "New — available",
  scheduled: "Scheduled — queued / in a send",
  sent: "Sent – accepted by SendGrid",
  unconfirmed: "Unconfirmed – needs manual check",
  failed: "Failed — can be resent",
  suppressed: "Suppressed — opted out",
};

export function RecipientLegend() {
  return (
    <div className={styles.legend}>
      {MERGED_STATUSES.map(s => {
        const chip = mergedStatusChip(s);
        return (
          <span key={s} className={styles.legendItem}>
            <span
              className={styles.statusDot}
              style={{ backgroundColor: chip.dotColor }}
              aria-hidden="true"
            />
            {LEGEND_HINTS[s]}
          </span>
        );
      })}
      <span className={styles.legendItem}>Response M/N — survey links responded / total</span>
    </div>
  );
}
